// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const RightArrow = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" d="M1.781 9H16.22m-5.907 5.906L16.22 9l-5.907-5.906" />
  </svg>
);
const ForwardRef = forwardRef(RightArrow);
export default ForwardRef;
